import { takeLatest, takeEvery } from 'redux-saga/effects';
import { connection } from 'decentraland-connect';
import { getAnalytics, trackConnectWallet } from './utils';
import { CONNECT_WALLET_SUCCESS } from '../wallet/actions';
export function createAnalyticsSaga(options = {
    LOCATION_CHANGE: '@@router/LOCATION_CHANGE'
}) {
    const { LOCATION_CHANGE } = options;
    return function* analyticsSaga() {
        yield takeLatest(CONNECT_WALLET_SUCCESS, handleConnectWalletSuccess);
        yield takeEvery(LOCATION_CHANGE, handleLocationChange);
    };
}
function handleConnectWalletSuccess(action) {
    const { wallet } = action.payload;
    const analytics = getAnalytics();
    if (analytics) {
        // Identify the user that has just connected.
        analytics.identify({ ethAddress: wallet.address });
        // Track useful connection data.
        // Not using the add function from utils to track the action automatically because
        // the analytics middleware will call this before the identify.
        trackConnectWallet({
            address: wallet.address,
            providerType: wallet.providerType,
            walletName: connection.getWalletName()
        });
    }
}
// Track pages
function handleLocationChange() {
    const analytics = getAnalytics();
    if (analytics) {
        analytics.page();
    }
}
//# sourceMappingURL=sagas.js.map